import { UserRoleE } from "../../models/enums";
import { RoutesE } from "../../routes/routesData";

/**
 * spec-38 T1 — where a role belongs when it has nowhere better to be.
 *
 * This mapping used to exist only inside `useAccount._redirect`, as a switch with a `navigate()` in
 * each arm, so nothing but the login/account-switch path could reuse it. Extracted as the DECISION
 * alone (role → path); the navigation stays where it was. `_redirect` now calls this, so there is
 * exactly one definition and the two cannot drift.
 *
 * ⚠️ Not the same thing as `privateRoutes`' `RoutesE.DEFAULT` catch-all, which sends EVERYONE to
 * `RoutesE.HOME` regardless of role. That is a separate behaviour with its own blast radius — do not
 * "unify" them here.
 */
export const getRoleHomeRoute = (role?: UserRoleE): string => {
  switch (role) {
    case UserRoleE.DeliveryService:
      return RoutesE.HOME_DELIVERY; // /projects/deliveryserviceindex

    case UserRoleE.Broadcaster:
      return RoutesE.DELIVERIES;

    case UserRoleE.MediaCompany:
      return RoutesE.CAMPAIGNS;

    default:
      return RoutesE.HOME;
  }
};
